import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import tz from 'dayjs/plugin/timezone';

export const getCurrentTimeInUserTZ = () => {
    dayjs.extend(utc);
    dayjs.extend(tz);
    const newEndTime = dayjs().tz(localStorage.getItem('userTZ') || '');
    let toTime = newEndTime?.format('YYYY-MM-DD HH:mm:ss')
    return toTime;
}

export const getTimeInUserTZ = (date: string, format: string = 'YYYY-MM-DD HH:mm:ss') => {
    dayjs.extend(utc);
    dayjs.extend(tz);
    const newEndTime = dayjs(date).tz(localStorage.getItem('userTZ') || '');
    let toTime = newEndTime?.format(format)
    return toTime;
}

export const getLastFetchedDetail = () => {
    const timezone = localStorage.getItem('userTZ') || '';
    // const options = { timeZone: timezone, hour: 'numeric', minute: 'numeric', hour12: true };
    const options: Intl.DateTimeFormatOptions = {
        timeZone: timezone,
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
    };

    // Get the current time in the specified timezone in 12-hour format
    const timeIn12HourFormat = new Date().toLocaleTimeString('en-US', options);

    return timeIn12HourFormat;
}

export const getLastFetchedDetailFromBrowser = () => {
    try {
        const options: Intl.DateTimeFormatOptions = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: true
        };
        const dateTimeIn12HourFormat = new Date().toLocaleString('en-US', options);
        return dateTimeIn12HourFormat;
    } catch (error) {
        console.log("error in getLastFetchedDetailFromBrowser", error)
        const options: Intl.DateTimeFormatOptions = {
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: true
        };
        const timeIn12HourFormat = new Date().toLocaleTimeString('en-US', options);
        return timeIn12HourFormat;
    }
}